import React, { useEffect, useState } from "react";
import { Modal, Button, Message } from "@arco-design/web-react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { FetchApi, PostApi } from "../Api/AuthenticatedApi";

// After login, if the signed-in email has pending org invites, prompt them to
// join. Mounted once in the app shell. Joining reloads so the new org's data and
// the switcher pick it up.
export default function InvitePrompt() {
    const { getAccessTokenSilently } = useAuth0();
    const navigate = useNavigate();
    const [invites, setInvites] = useState([]);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        FetchApi(getAccessTokenSilently, "/api/me",
            (data) => {
                const pending = (data && data.pending_invites) || [];
                if (pending.length > 0) {
                    setInvites(pending);
                    setOpen(true);
                }
            },
            () => {}, () => {});
    }, [getAccessTokenSilently]);

    const join = (inv) => {
        PostApi(getAccessTokenSilently, "/api/invites/" + inv.id + "/accept",
            () => { Message.success("Joined " + (inv.organization_name || "organization")); window.location.href = "/"; },
            () => navigate("/login"),
            (err) => Message.error((err && err.message) || "Failed to join organization"));
    };

    if (!open || invites.length === 0) {
        return null;
    }

    return (
        <Modal title="You've been invited" visible={open} footer={null} onCancel={() => setOpen(false)}>
            <p style={{ color: "var(--color-text-3)", marginTop: 0 }}>You've been invited to join:</p>
            {invites.map((inv) => (
                <div
                    key={inv.id}
                    style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid var(--color-border-2)" }}
                >
                    <span style={{ fontWeight: 500 }}>{inv.organization_name || "An organization"}</span>
                    <Button type="primary" size="small" onClick={() => join(inv)}>Join</Button>
                </div>
            ))}
            <div style={{ marginTop: 16, textAlign: "right" }}>
                <Button size="small" onClick={() => setOpen(false)}>Not now</Button>
            </div>
        </Modal>
    );
}
